import React, { useState, useEffect } from 'react';
import SEO from '../components/SEO';
import { useParams, useNavigate } from 'react-router-dom';
import 'react-quill/dist/quill.snow.css'; // Import Quill styles
import ReactQuill from 'react-quill';
import { FaEllipsisV } from 'react-icons/fa'; // Import the three dots icon
import '../styles/EditDocumentPage.css';
import { useDocumentsV2 } from '../context/DocumentsContextV2'; // Updated import
import { baseUrl } from '../config';



const EditDocumentPage = () => {
  const { id } = useParams();
  const { documents, updateDocument } = useDocumentsV2(); // Use new context
  const navigate = useNavigate();
  
  const [document, setDocument] = useState({
    content: '',
  });
  
  const [aiAssistance, setAiAssistance] = useState(false);
  const [selectedRange, setSelectedRange] = useState({ start: 0, end: 0 });
  const [showAiMenu, setShowAiMenu] = useState(false); // State to toggle the AI menu

  useEffect(() => {
    const docToEdit = documents.find((doc) => doc.id === id);
    if (docToEdit) {
      setDocument(docToEdit);
    }
  }, [id, documents]);

  const handleUpdate = () => {
    if (document.content) {
      updateDocument(document);
      navigate('/');
    } else {
      alert('Please fill in the content.');
    }
  };

  const handleAiAssistance = (modifyAll = false) => {
    setAiAssistance(true);
    setShowAiMenu(false);
    // Placeholder: AI integration logic goes here
    if (modifyAll) {
      // Handle AI modification for all lines
    } else {
      // Handle AI modification for selected range
    }
  };

  const handleRangeChange = (e) => {
    const { name, value } = e.target;
    setSelectedRange((prevRange) => ({
      ...prevRange,
      [name]: Number(value),
    }));
  };

  const toggleAiMenu = () => {
    setShowAiMenu(!showAiMenu);
  };

  return (
    <div className="edit-document-page">
      <SEO
        title="Edit Document"
        description="Edit and update documents for your film production project on ProducerBuddy."
        url="https://producerbuddy.pilomation.com/edit-document"
        robots="noindex, nofollow"
      />
      <h2>Edit Document</h2>
      <div className="edit-form">
        <label>Content</label>
        <ReactQuill
          value={document.content}
          onChange={(content) => setDocument({ ...document, content })}
          modules={{
            toolbar: [
              [{ header: [1, 2, false] }],
              ['bold', 'italic', 'underline', 'strike', 'blockquote'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              ['link', 'image'],
              ['clean'],
            ],
          }}
        />

        <div className="form-buttons">
          <button onClick={handleUpdate} className="update-button">Update</button>
          <button onClick={() => navigate('/')} className="cancel-button">Cancel</button>
          
          <div className="ai-assist-container">
            <button onClick={toggleAiMenu} className="ai-menu-button">
              <FaEllipsisV />
            </button>
            {showAiMenu && (
              <div className="ai-menu">
                <button onClick={() => handleAiAssistance(true)} className="ai-menu-option">
                  Modify All Lines
                </button>
                <button onClick={() => setAiAssistance(true)} className="ai-menu-option">
                  Select Line Range
                </button>
              </div>
            )}
          </div>
        </div>

        {aiAssistance && (
          <div className="ai-assistance-section">
            <h3>AI Assistance</h3>
            <div>
              <label>Select Range: </label>
              <input
                type="number"
                name="start"
                placeholder="Start line"
                value={selectedRange.start}
                onChange={handleRangeChange}
              />
              <input
                type="number"
                name="end"
                placeholder="End line"
                value={selectedRange.end}
                onChange={handleRangeChange}
              />
              {/* Placeholder for AI generated suggestions */}
              <div className="ai-suggestions">
                <p>AI suggestions will be shown here for the selected range.</p>
              </div>
            </div>
            <div className="form-buttons">
              <button onClick={() => handleAiAssistance(false)} className="update-button">
                Apply AI Modification
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EditDocumentPage;

